// test1821
(1821 && 0);
